import { useState } from "react";

export default function (defaultValue: boolean = false): [boolean, () => void] {
    const [value, setValue] = useState(defaultValue);

    return [
        value,
        () => setValue(!value),
    ];
}